/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SelectionRequest } from '../../models/selection-request';
import { SelectionResponse } from '../../models/selection-response';

export interface CreateSelection$Plain$Params {
  
    /**
     * Selection request containing User1 (sender) and User2 (recipient) emails
     */
    body?: SelectionRequest
}

export function createSelection$Plain(http: HttpClient, rootUrl: string, params?: CreateSelection$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<SelectionResponse>> {
  const rb = new RequestBuilder(rootUrl, createSelection$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SelectionResponse>;
    })
  );
}

createSelection$Plain.PATH = '/api/Selection';
